import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, BRAND } from "@/content";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-[var(--ic-line)]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex items-center justify-between h-[72px]">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2">
          <span className="font-serif text-[24px] leading-none tracking-tight">I&nbsp;Choose</span>
          <span className="overline hidden sm:inline">Movement</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-[12px] tracking-[0.22em] uppercase transition-opacity ${
                  isActive ? "text-black" : "text-black/60 hover:text-black"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/speaking#inquiry"
          data-testid="nav-cta-book"
          className="hidden lg:inline-flex btn-ink"
        >
          Book Crystal
        </Link>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 -mr-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="lg:hidden bg-white border-t border-[var(--ic-line)]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`m-${l.testid}`}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `font-serif text-3xl tracking-tight ${isActive ? "text-black" : "text-black/70"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/speaking#inquiry" data-testid="m-nav-cta-book" className="btn-ink mt-4 justify-center">
              Book Crystal to Speak
            </Link>
            <a href={BRAND.calendly} target="_blank" rel="noreferrer" className="btn-ghost justify-center">
              Book a Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
